import React, { useCallback } from 'react';
import classNames from 'classnames';
import ArrowrightIcon from 'icons/Arrowright.icon';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import { Lead } from 'models/Lead';
import { isNdaNotSent } from 'utils';
import useNdaStatus, { LeadNdaProps } from 'hooks/useNdaStatus';
import AutomaticMessageModal from 'components/AutomaticMessageModal';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';

import './SendNda.styles.scss';

type SendNdaProps = {
  className?: string;
  lead: Lead;
  updateLead: (lead: Lead) => void;
};

const SendNda: React.FC<SendNdaProps> = (props) => {
  const { className, lead, updateLead } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  const classes = classNames('send-nda', className);

  const {
    _id: leadId,
    envelopeTemplateId,
    envelopeId,
    signingStatus,
    firstName,
    lastName,
  } = lead;

  const { t } = useTranslation();

  const updateNdaProps = useCallback(
    (leadNdaProps: LeadNdaProps) => {
      updateLead({
        ...lead,
        ...leadNdaProps,
      });
    },
    [lead, updateLead],
  );

  const { isLoading, sendNda } = useNdaStatus(
    leadId,
    envelopeId,
    updateNdaProps,
  );

  if (!envelopeTemplateId || !isNdaNotSent(signingStatus)) return null;

  return (
    <>
      <Button
        className={classes}
        variant="outline"
        iconPosition="right"
        icon={ArrowrightIcon}
        disabled={isLoading}
        onClick={(e) => {
          e.stopPropagation();
          modal?.open();
        }}
      >
        {t('sendNda')}
      </Button>

      <AutomaticMessageModal
        ref={modalRef}
        leadFirstName={firstName}
        leadLastName={lastName}
        onSendNda={(message) => {
          modal?.close();
          sendNda(message);
        }}
      />
    </>
  );
};

export default SendNda;
